'use strict';

angular.module('app.campaignActivity')
    .directive('campaignInfluencerPosts', function ($rootScope, $http) {
        var controller = function ($scope, $location, $state) {
            var vm = this;
            var pieChartConfig = {
                options: {
                    chart: {
                        type: 'pie',
                        zoomType: 'x',
                        backgroundColor: null,
                        marginBottom: 0,
                        marginLeft: 0,
                        marginRight: 0,
                        marginTop: 10,
                        width: 40,
                        height: 40,
                        style: {
                            "overflow": "visible"
                        }
                    },
                    tooltip: {
                        useHTML: true,
                        followPointer: false,
                        hideDelay: 0,
                        backgroundColor: "#333b48",
                        headerFormat: "",
                        borderRadius: 24,
                        borderWidth: 0,
                        shadow: false,
                        shape: "callout",
                        style: {
                            "color": "#FFFFFF",
                            "padding": "6"
                        },
                        positioner: function (boxWidth, boxHeight, point) {
                            var chart = this.chart,
                                plotLeft = chart.plotLeft,
                                plotTop = chart.plotTop,
                                plotWidth = chart.plotWidth,
                                plotHeight = chart.plotHeight;
                            return { x: chart.plotLeft + chart.plotWidth / 2 - boxWidth / 2, y: chart.plotTop - boxHeight / 2 - 20 };
                        },
                        pointFormatter: function () {
                            if (this.name == 'Other') {
                                if (this.series.points[0].name == 'Impact') {
                                    return this.series.points[0].name + ': ' + Highcharts.numberFormat(this.series.points[0].value, 0, 0, ',') + '%';
                                } else {
                                    return this.series.points[0].name + ': ' + Highcharts.numberFormat(this.series.points[0].value, 0, 0, ',');
                                }

                            } else {
                                if (this.name == 'Impact') {
                                    return this.name + ': ' + Highcharts.numberFormat(this.value, 0, 0, ',') + '%';
                                } else {
                                    return this.name + ': ' + Highcharts.numberFormat(this.value, 0, 0, ',');
                                }

                            }
                        }
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: false,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: false
                        }
                    },

                    credits: {
                        enabled: false
                    }
                },
                series: [
                    {
                        size: '31',
                        innerSize: '25',
                        states: {
                            hover: {
                                halo: {
                                    size: 1
                                }
                            }
                        }
                    }
                ],
                title: {
                    text: '',
                    style: {
                        fontSize: '16px',
                        color: '#4B5567',
                        fontFamily: 'ProximaNovaRegular'
                    }
                },
                xAxis: {
                    type: 'datetime',
                    title: {
                        text: 'Date'
                    }
                },
                noData: 'Pending Data...',
                loading: true
            };

            vm.gotoPostOverviewPage = function (post) {
                $rootScope.previousPagePost = $location.absUrl();
                var url_getPlatform = $rootScope.apiUrl + 'overview/getPlatFormPostByRelativepath?relativepath=' + post.relativepath;
                $http.get(url_getPlatform).success(function (response) {
                    if (response.data == 1) {
                        $state.transitionTo('home.blogPostOverview', { url: post.full_url, relativepath: post.relativepath }, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    } else if (response.data == 2) {
                        $state.transitionTo('home.instagramPostOverview', { url: post.full_url, relativepath: post.relativepath }, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    } else if (response.data == 6) {
                        $state.transitionTo('home.youtubePostOverview', { url: post.full_url, relativepath: post.relativepath }, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    } else if (response.data == 7) {
                        $state.transitionTo('home.facebookPostOverview', { url: post.full_url, relativepath: post.relativepath }, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    }
                });
            }

            function configureCharts() {
                $rootScope.$broadcast('showLoader', { controller: 'myHttpInterceptor' });
                var item;
                _.forEach(vm.posts, function (post) {
                    item = post;

                    // Reach
                    item.reach.pieChartConfig = angular.copy(pieChartConfig);
                    item.reach.pieChartConfig.series[0].name = item.name;
                    item.reach.pieChartConfig.series[0].data = [{ name: 'Reach', color: '#FF6C9D', y: _.get(item, 'reach.percent'), value: _.get(item, 'reach.value') },
                    { name: 'Other', color: '#EEF2F4', y: (1 - _.get(item, 'reach.percent')), value: _.get(item, 'reach.other') }];

                    // Engagement
                    item.engagement.pieChartConfig = angular.copy(pieChartConfig);
                    item.engagement.pieChartConfig.series[0].name = item.name;
                    item.engagement.pieChartConfig.series[0].data = [{ name: 'Engagement', color: '#00D6EF', y: _.get(item, 'engagement.percent'), value: _.get(item, 'engagement.value') },
                    { name: 'Other', color: '#EEF2F4', y: (1 - _.get(item, 'engagement.percent')), value: _.get(item, 'engagement.other') }];

                    // Impact
                    item.impact.pieChartConfig = angular.copy(pieChartConfig);
                    item.impact.pieChartConfig.series[0].name = item.name;
                    item.impact.pieChartConfig.series[0].data = [{ name: 'Impact', color: '#4A5568', y: _.get(item, 'impact.percent'), value: _.get(item, 'impact.value') },
                    { name: 'Other', color: '#EEF2F4', y: (1 - _.get(item, 'impact.percent')), value: _.get(item, 'impact.other') }];
                });

                setTimeout(function () {
                    $rootScope.$broadcast('hideLoader', { controller: 'myHttpInterceptor' });
                }, 2000);
            }

            $scope.$watch('vm.posts', function(newValue, oldValue){
                if (newValue != oldValue){
                    configureCharts();
                }
            });
       }

        return {
            restrict: 'E',
            scope: {
                posts: '=',
                showKpi: '='
            },
            controller: controller,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'app/campaign/campaignActivityPage/influencerPosts/campaignInfluencerPosts.html?app_v=deployDate'
        };
    });